export default __webpack_public_path__ + "static/media/Tech-Augmented-Workforce.ab21636d.pdf";